import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../common.css";
import "../investorAcademy.css";
import InvestorAcademyCommon from '../../../../components/common/InvestorAcademyCommon';



const Risks = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const location = useLocation();
  const history = useHistory();

  return (
    <div id="investor_academy">
      <div className="imgbg" />
      <div className="mainbg"></div>
      <div
        id="main"
      >
        <div
          id="maintable" className='Common_warrent'
          style={{ display: "table", width: "100%", tableLayout: "fixed" }}
        >
          <div style={{ display: "table-row" }}>
            <div
              id="leftbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            />



            <div id="maincontainer" style={{ display: "table-cell", width: "100%" }}>
              <div id="mainnav">
                <table
                  style={{
                    width: "100%",
                    tableLayout: "fixed",
                    borderBottom: "1px solid #353223",
                  }}
                >
                  <tbody>
                    <tr>
                      <td width="20%" style={{ textAlign: "left", visibility: "hidden" }}>
                        <table
                          className="hasprev hidden-xs"
                          style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <td width="33px">
                                <div className="prev left" />
                              </td>
                              <td>
                                <div className="prevlbl left">
                                  <div
                                    className="prevtitle "
                                    style={{ textAlign: "left" }}
                                  />
                                  <div className="prevname " style={{ textAlign: "left" }}>
                                    Put example
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width="60%" style={{ textAlign: "center" }}>
                        <div
                          id="pagetitlediv"
                          style={{
                            width: "365px",
                            height: "100%",
                            borderBottom: "1px solid #FFD843",
                            margin: "auto",
                          }}
                        >
                          <div
                            id="ptitle"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "25px",
                              color: "white",
                              letterSpacing: "1px",
                            }}
                          >
                            <img height="56px" src='/img/education/010.png' alt="image" />
                          </div>
                          <div
                            id="pname"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "30px",
                              color: "#FFD843",
                              letterSpacing: "1px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                            }}
                          >
                            Risks
                          </div>
                        </div>
                      </td>
                      <td width="20%" style={{ textAlign: "right", visibility: "hidden" }}>
                        <table
                          className="hasnext  hidden-xs"
                          style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <td>
                                <div className="nextlbl right">
                                  <div
                                    className="nexttitle "
                                    style={{ textAlign: "right" }}
                                  />
                                  <div className="nextname " style={{ textAlign: "right" }}>
                                    Market Risk
                                  </div>
                                </div>
                              </td>
                              <td width="33px">
                                <div className="next right" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                id="maincontent"
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  paddingTop: "40px",
                  marginBottom: "60px",
                }}
              >
                <div
                  id="mainscroll"
                  style={{
                    height: "100%",
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingLeft: "90px",
                    paddingRight: "90px",
                  }}
                >
                  <div id="mainscrollcontent">
                    <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                    <title>Risk</title>
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n            .hexrow.even{\n                margin-left: 73px;\n            }\n        ",
                      }}
                    />
                    <div className="contentbox">
                      <p>
                        By the end of the tutorial, you’ll have a clear picture of how five
                        key risks that can impact your investment. The five risks we will be
                        exploring include market risk, gearing, limited life, credit risk
                        and takeovers. Potential investors should refer to the risk factors
                        detailed in the Base Prospectus and the relevant Supplementary Base
                        Prospectus.
                      </p>
                      <p className="showtile">
                        Please click on each of the tiles below for more details
                      </p>
                      <div className="hexmenu hide_mobile">
                        <div className="hexrow odd">
                          <div
                            className="hex color01"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/risks/market-risk">
                              <span className="text-black "> Market Risk</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                          <div
                            className="hex color02"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/risks/gearing">
                              <span className="text-black ">Gearing</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                          <div
                            className="hex color03"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/risks/limited-life">
                              <span className="text-black ">Limited Life</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                        </div>
                        <div className="hexrow even last">
                          <div
                            className="hex color04"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/risks/credit-risk">
                              <span className="text-black ">Credit Risk</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                          <div
                            className="hex color05"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/risks/takeovers">
                              <span className="text-black ">Takeovers</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                        </div>
                      </div>
                      <div className='square_hex'>
                        <div className="hex1">
                          <div>
                            <Link to="/edu/risks/market-risk">
                              <img src='/img/education/limited_loss.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                          <Link to="/edu/risks/market-risk">
                              <span className="text-black "> Market Risk</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/risks/market-risk">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/risks/gearing">
                              <img src='/img/education/effective_gearing.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                          <Link to="/edu/risks/gearing">
                              <span className="text-black ">Gearing</span>
                            </Link> 
                          </div>
                          <div>
                            <Link to="/edu/risks/gearing">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/risks/limited-life">
                              <img src='/img/education/litmited_life.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                          <Link to="/edu/risks/limited-life">
                              <span className="text-black ">Limited Life</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/risks/limited-life">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                          <Link to="/edu/risks/credit-risk">
                              <img src='/img/education/credit_risk.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                          <Link to="/edu/risks/credit-risk">
                              <span className="text-black ">Credit Risk</span>
                            </Link>
                          </div>
                          <div>
                          <Link to="/edu/risks/credit-risk">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                          <Link to="/edu/risks/takeovers">
                              <img src='/img/education/takeovers.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                          <Link to="/edu/risks/takeovers">
                              <span className="text-black ">Takeovers</span>
                            </Link>
                          </div>
                          <div>
                          <Link to="/edu/risks/takeovers">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>
                <div
                  id="rightbar"
                  className="hidden-xs"
                  style={{ display: "table-cell", width: "80px" }}
                ></div>
              </div>
            </div>



            <div
              id="rightbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            ></div>
          </div>
        </div>
      </div>


      <div
        id="bottom"
        style={{
          position: "fixed",
          width: "100%",
          bottom: "0px",
          height: "40px",
          backgroundColor: "#101010",
          zIndex: 10000,
        }}
      >
        <div
          className="hidden-xs hidden-xxs"
          style={{
            display: "table",
            width: "100%",
            textAlign: "center",
            color: "#8F8F8F",
            fontSize: "11px",
            lineHeight: "40px",
          }}
        >
        <div className='copyright_sec'>
        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
          reserved.
        </div>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            right: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasnext"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td>
                  <div className="nextlbl right">
                    <div
                      className="nextname "
                      style={{ textAlign: "right", fontSize: "15px" }}
                    >
                      <Link to="/edu/risks/market-risk">
                        <span className="prevname "> Market Risk</span>
                      </Link>
                    </div>
                  </div>
                </td>
                <td width="33px">
                  <Link to="/edu/risks/market-risk">
                    <div className="next right" />
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            left: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasprev"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td width="33px">
                  <Link to="/edu/index-calls/put-example">
                    <div className="prev left" />
                  </Link>
                </td>
                <td>
                  <div className="prevlbl left">
                    <div
                      className="prevname "
                      style={{ textAlign: "left", fontSize: "15px" }}
                    >
                      <Link to="/edu/index-calls/put-example">
                        <span className="prevname ">Put example</span>
                      </Link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
        {/* <div className="dbtn dbtn-seminarbtn">
          <Link
            className="seminarbtn"
            to="/education/seminar"
          >
            <img src='/img/education/button-static.png' alt="image" />
          </Link>
        </div> */}
        <InvestorAcademyCommon Location={location} Hist={history} />
      </div>

    </div>
  );
}
export default Risks;